export default __webpack_public_path__ + "static/media/icoPerson.9d708531.svg";